import api from './api';

const BASE = '/kerrscreen-files';

export const kerrscreenFilesService = {
  // Get all art files (paginated, filterable)
  getAll: (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.search) params.append('search', filters.search);
    if (filters.folderId !== undefined) params.append('folderId', filters.folderId);
    if (filters.page) params.append('page', filters.page);
    if (filters.limit) params.append('limit', filters.limit);
    if (filters.customerName) params.append('customerName', filters.customerName);
    if (filters.jobId) params.append('jobId', filters.jobId);
    if (filters.tag) params.append('tag', filters.tag);

    const queryString = params.toString();
    return api.get(`${BASE}/files${queryString ? `?${queryString}` : ''}`);
  },

  // Get single art file
  getById: (id) => api.get(`${BASE}/files/${id}`),

  // Upload art file with progress tracking
  upload: (formData, onUploadProgress) => {
    return api.post(`${BASE}/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 600000, // 10 minutes for large art files
      onUploadProgress,
    });
  },

  // Create folder
  createFolder: (data) => api.post(`${BASE}/folders`, data),

  // Update metadata (tags, customer, notes)
  update: (id, data) => api.put(`${BASE}/files/${id}`, data),

  // Rename
  rename: (id, name) => api.patch(`${BASE}/files/${id}/rename`, { name }),

  // Move to folder
  move: (id, parentFolderId) => api.patch(`${BASE}/files/${id}/move`, { parentFolderId }),

  // Delete
  delete: (id) => api.delete(`${BASE}/files/${id}`),

  // Download
  download: (id) => api.get(`${BASE}/files/${id}/download`, { responseType: 'blob' }),

  // Stats
  getStats: () => api.get(`${BASE}/stats`),

  // Art files by job
  getByJob: (jobId) => api.get(`${BASE}/by-job/${jobId}`),

  // Link/unlink to job
  linkToJob: (id, jobId) => api.post(`${BASE}/files/${id}/link-job`, { jobId }),
  unlinkFromJob: (id, jobId) => api.delete(`${BASE}/files/${id}/link-job/${jobId}`),

  // Filter options
  getCustomers: () => api.get(`${BASE}/customers`),
  getTags: () => api.get(`${BASE}/tags`),
};

export default kerrscreenFilesService;
